export function allow(allowedGroups: string[], currentUserGroups: string[]) {
  return (
    allowedGroups.filter(function (e) {
      return currentUserGroups.indexOf(e) > -1;
    }).length > 0
  );
}
